import { employeeDocumentDownloadDescription as description } from './description';
import { download as execute } from './execute';

export { description, execute };
